import { jsx } from "panel";
import { RowLabelType, SelectorTypeDefinitions } from "common/query-builder/query-entry-section/types";
import { StringOperator } from "common/widgets/property-filter-menu/models/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/row-types/base/query-entry-section-el";
import { getProjectId, getWorkspaceId } from "common/report/util";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
export function template() {
  const segment = this.params.segment;
  const listProperty = this.params.listProperty;
  const filters = this.getFilters();
  const commonEntryParams = {
    filters: [],
    filterOnly: true,
    hideListQuantifier: true,
    quickDelete: true,
    suppressTracking: true,
    type: SelectorTypeDefinitions.Filter,
    event: this.createTemplateFilter(segment).getAttributes()
  };
  const placeholderRow = {
    ...commonEntryParams,
    quickDelete: false,
    operatorOverrides: this.getFilterOperatorOverrides(filters.length)
  };
  const disableFilterSection = filters.length >= 10;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-string-bucket-pane"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".input-area"
  }, /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    class: { "contained-section": true, "indent-filters": true },
    attrs: {
      "disable-add-entry": true,
      disabled: disableFilterSection,
      "row-index": 0,
      "row-label-type": RowLabelType.None,
      "add-entry-button-label": `Select Value`,
      entries: [
        ...filters.map((event, idx) => ({
          ...commonEntryParams,
          event,
          quickRename: event.filterOperator === StringOperator.Equals,
          operatorOverrides: this.getFilterOperatorOverrides(idx)
        })),
        placeholderRow
      ],
      "event-names": this.params.eventNames,
      "project-id": parseInt(getProjectId()),
      "workspace-id": parseInt(getWorkspaceId()),
      "row-types": [{ placeholderEntry: commonEntryParams, value: SelectorTypeDefinitions.Filter }],
      "track-properties": { sectionName: `customize-string-group` }
    },
    params: {
      ...listProperty ? { listProperty } : {}
    },
    on: {
      update: (ev) => this.handleFiltersUpdate(ev),
      keyup: (ev) => ev.stopPropagation()
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".remaining-values"
  }, /* @__PURE__ */ jsx("span", null, "Else remaining values"), /* @__PURE__ */ jsx("div", {
    sel: ".help-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info-xs` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      "image-src": require(`common/assets/images/custom-groups/nonoverlapping-segments.svg`),
      "max-width": `150px`,
      placement: Placement.RightCenter,
      text: `All other values will be
included in this group`
    }
  })))));
}
